import { render, staticRenderFns } from "./NuevoProveedor.vue?vue&type=template&id=1af2e8e8"
import script from "./NuevoProveedor.vue?vue&type=script&lang=js"
export * from "./NuevoProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports